import React from "react";
import img from "../../../Assets/Images/About/about-bg-06.png";
import plusIcon from "../../../Assets/Images/About/plus-icon.png";
import equalIcon from "../../../Assets/Images/About/equal-icon.png";
import "./style.scss";
import { useTranslation } from "react-i18next";

function Capabilities() {
    const { t } = useTranslation();
    return (
        <div className="capability">
            <img className="mainImg" src={img} alt="" />
            <div className="plus-icon">
                <img src={plusIcon} alt="" />
            </div>
            <div className="equal-icon">
                <img src={equalIcon} alt="" />
            </div>
            <div className="content">
                <div className="content-plus">
                    {detailContent(t("capabilities.solution.title"), t("capabilities.solution.detail1"), t("capabilities.solution.detail2"))}
                    {detailContent(t("capabilities.experience.title"), t("capabilities.experience.detail1"), t("capabilities.experience.detail2"))}
                </div>
                <div className="content-equal">{detailContent(t("capabilities.capabilities.title"), t("capabilities.capabilities.detail1"), t("capabilities.capabilities.detail2"))}</div>
            </div>
        </div>
    );
}

export default Capabilities;

const detailContent = (title: string, detail1: string, detail2: string) => (
    <div className="content-detail">
        <div className="title">{title}</div>
        <div className="detail">
            {detail1} <br />
            {detail2}
        </div>
    </div>
);
